import valid from "card-validator";

export const getCardType = (cardNumber: string) => {
  const cardType = valid.number(cardNumber).card?.type;
  return cardType;
};
